import { set, cloneDeep, find, merge } from "lodash";
import { twdClass } from "../../../constants/tailwind.constants";
import { StyleBtn, SettingsBtn, CollapseBtn} from "../../ui/presets";
import {
  UPDATE_BLOCK_DATA,
  UPDATE_STYLE_ID,
  UPDATE_STYLE_PART,   
  ADD_RIGHT_PANEL_LEVEL, 
  UPDATE_ADVANCED_ID,
  RIGHT_PANEL_TOGGEL,
  UPDATE_PROJECT_INFO,
  UPDATE_PROJECT_PAGE,
  UPDATE_PAGE_CONFIG,
} from "../../../constants/action.constants";


import { useDispatch, useSelector} from "react-redux";
import { Button} from "../../ui/com_ui";
import { useState, useEffect} from "react";
import { toast } from "react-toastify";
import PageDesigns from "../pageConfig/PageDesigns";
import PageVariables from "../pageConfig/PageVariables";
import PageData from "../pageConfig/PageData";




const PageDesign2 = ({updatePageProps, hideDesigns}) => {
  const {
    pageInfo
  } = useSelector((state) => state.studioDetails); 

  const onSelectDesign = (design) => {
    //console.log('design', design.metaData.blocks)
    let blocks_selected_bk= pageInfo.blocks_selected_bk ? pageInfo.blocks_selected_bk : pageInfo.blocks  
    
    updatePageProps([ 
      ["design_selection", 'processing'],
      ["blocks_selected_bk", blocks_selected_bk],
      ["blocks", design.metaData.blocks]
    ])
    
    toast.success("Page Design updated");
  }
  return <PageDesigns loc={'sidebar'} onApply={onSelectDesign} hideDesigns={hideDesigns}/>
}

const PageVariables2 = ({updatePageProps}) => {
  const {
    pageInfo
  } = useSelector((state) => state.studioDetails); 
  const {settings={}} = pageInfo
  

  const updateParamsValues = (item) => {
    
   const settings2 = cloneDeep(settings);
    const rec = find(settings2.paramsValues, ["replaceTo", item.replaceTo]);
    if (rec) {
      merge(rec, item);
    } else {
      settings2.paramsValues.push(item);
    } 
    console.log("item", item, settings2.paramsValues)
     
    updatePageProps([ 
      ["settings", settings2],
    ])
    
  };  
  return <PageVariables loc={'sidebar'} {...{updatePageProps, updateParamsValues}}/>
}

const PageData2 = ({updatePageProps}) => {
  const dispatch = useDispatch();
  const {
    pageInfo,
    pageConfig,
  } = useSelector((state) => state.studioDetails);

  const {blocks_selected_bk=false, blocks=[], settings={}} = pageInfo
  const {original=false} = pageConfig

  

  let blks= blocks_selected_bk ? blocks_selected_bk : blocks
  let original2 = original && original.length ? original : blocks

  console.log("original2", original2)
  const apply = (dynamic_preview_blocks=[]) => {
    
    let preview=dynamic_preview_blocks
    dispatch({
      type: UPDATE_PAGE_CONFIG,
      data: {
        ...pageConfig,
        original:original2
      },
    });
    console.log("dynamic_preview_blocks", dynamic_preview_blocks)
    updatePageProps([ 
      ["blocks", preview]
    ])
  }  
  return <PageData loc={'sidebar'} {...{apply, orig_blocks:original2, updatePageProps}}/>
}

const PageConfig = ({ }) => {
  
  const dispatch = useDispatch();
  const {
    pageInfo,
    pageConfig,
    rightPanelLevels
  } = useSelector((state) => state.studioDetails);  
  
  const {blocks=[], settings={}} = pageInfo
  const {original=false} = pageConfig
  const {pageType='', sheetColumns=[], paramsValues=[]} = settings

  const [autoTab, setAutoTab] = useState(true);
  const [tab, setTab] = useState(blocks.length ? 'variables':'design');

  const closeDynamicPreview = () => {    
    if(original) {
      updatePageProps([ 
        ["blocks", original]
      ])
    }
    dispatch({ type: UPDATE_PAGE_CONFIG, data:{...pageConfig, original:false}});
  }
  const DesignTab = (<Button
    type={'default'}
    color={tab =='design' ? 'black' : 'white'}
    size={'sm'}
    cType={''}
    className={twdClass(``)}
    onClick={()=>{
      setAutoTab(false)
      setTab("design")  
      closeDynamicPreview()    
    }}          
  >             
    Design</Button>)
  const VariablesTab = (<Button
      type={'default'}
      color={tab =='variables' ? 'black' : 'white'}
      size={'sm'}
      cType={''}
      className={twdClass(``)}
      onClick={()=>{
        setTab('variables')  
        setAutoTab(false)
        closeDynamicPreview()          
      }}          
    >
      Variables</Button>)
  const DataTab = (<Button
    type={'default'}
    color={tab =='data' ? 'black' : 'white'}
    size={'sm'}
    cType={''}
    className={twdClass(``)}
    onClick={()=>{
      setAutoTab(false)
      setTab('data')
    }}          
  >
    Data Preview</Button>)

  const tabs = []
  tabs.push({name:'design', component:DesignTab})
  if(pageType=='dynamic') tabs.push({name:'variables', component:VariablesTab})
  if(pageType=='dynamic') tabs.push({name:'data', component:DataTab})

  const hideDesigns = blocks.length ? true : false
  const updatePageProps = (pageProps =[]) => {
    let data = cloneDeep(pageInfo)
    pageProps.map((prop)=>{
      data = set(data, prop[0], prop[1]);
    })
    //console.log("update", data)
    dispatch({ type: UPDATE_PROJECT_PAGE, data });
  };

  useEffect(() => {
    if(!autoTab) return false
    if(pageType=='dynamic'){
      if(blocks.length && tab=='design') {
        setTab("variables")
      }else if(!blocks.length) {
        setTab("design")
      }
    }
  }, [blocks]);

  return (
    <>
      <div className={twdClass("px-3 py-3 flex items-center")}>
        <div className={twdClass("flex-grow flex items-center")}>
          <div            
            className={twdClass("mr-4")}
          >
            <img src={'/assets/images/space-horizontal.svg'}/>
          </div>
          <div>
            <div className={twdClass("text-gray-900 text-lg font-semibold")}>Page Config</div>
            <div className={twdClass("text-xs")}></div>
          </div>
        </div>
      </div>
      <div className={twdClass('border-b border-gray-200 pb-2 flex items-center gap-2 px-3')}>
        {tabs.map(({component})=>{
          return component
        })}
      </div>
      <div className={twdClass("px-3 py-3")}>
        {(tab=='design') && <PageDesign2 {...{hideDesigns, updatePageProps}}/>}
        {(pageType=='dynamic' && tab=='variables') && <PageVariables2 {...{updatePageProps}}/>}
        {(pageType=='dynamic' && tab=='data') && <PageData2 {...{updatePageProps}}/>}
      </div>
    </>
  );
};

export default PageConfig;
